import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { UserService } from '@intranet/modules/users/user.service';
import { LoginService, UserGroup } from '../..';
import { HotkeyService } from 'src/app/core/services/hotkey.service';

@Component({
    selector: 'admin-groups',
    templateUrl: './admin-groups.component.html',
    styleUrls: ['./admin-groups.component.scss'],
})
export class AdminGroupsComponent implements OnInit {
    isLoading: boolean = false;
    groups: UserGroup[] | null;
    allGroups: UserGroup[];
    error: string | null;
    selectedUserGroup: UserGroup | null;
    showActive = true;
    showDialog = false;

    constructor(
        protected loginService: LoginService,
        private userService: UserService,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this._loadUserGroups();

        // Register hotkey for "Add Group" (Ctrl + Shift + A)
        this.hotkeyService.registerHotkey('ctrl+shift+a', 'Add Group', () => {
            this.onClickToggle();
        });
    }

    onUserGroupSelected(userGroup: UserGroup) {
        this.selectedUserGroup = userGroup;
        this.showDialog = true;
    }

    onUserGroupUpdated(userGroup: UserGroup) {
        this._loadUserGroups();
    }

    onStatus(status: string | 'active'): void {
        this._filter(status);
    }

    onClickToggle() {
        this.selectedUserGroup = null;
        this.showDialog = true;
    }

    private _filter(status: string) {
        this.groups = this.allGroups.filter((u) => status === 'active' ? u.active : !u.active);
    }

    private _loadUserGroups() {
        this.isLoading = true;
        this.userService
            .getUserGroups()
            .pipe(
                tap(response => {
                    this.allGroups = response.groups;
                    this._filter('active');
                }))
            .subscribe({
                error: (err) => (this.error = err),
                complete: () => (this.isLoading = false)
            });
    }
}
